import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const resolveLogo = (p) => (p && (p.startsWith("/api/") || p.startsWith("/uploads/"))) ? `${BACKEND}${p}` : (p || "");

export default function Login() {
    const { login, user, loading } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    const [namaPerusahaan, setNamaPerusahaan] = useState("CV. Meranggi Jaya Garment");

    useEffect(() => {
        api.get("/pengaturan/public").then((r) => {
            setLogoUrl(r.data?.logo_url || "");
            if (r.data?.nama_perusahaan) setNamaPerusahaan(r.data.nama_perusahaan);
        }).catch(() => { /* public */ });
    }, []);

    if (loading) return null;
    if (user) return <Navigate to="/dashboard" replace />;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrMsg("");
        if (!email.trim() || !password) {
            setErrMsg("Email dan password wajib diisi");
            return;
        }
        setSubmitting(true);
        const res = await login(email.trim().toLowerCase(), password);
        setSubmitting(false);
        if (res.ok) {
            nav("/dashboard");
        } else {
            setErrMsg(res.message || "Login gagal");
        }
    };

    return (
        <div className="login-split" data-testid="login-page">
            {/* Brand panel — compact header on mobile, full column on desktop */}
            <div className="login-brand-panel">
                <div style={{ textAlign: "center", maxWidth: 420 }}>
                    {logoUrl ? (
                        <img
                            src={resolveLogo(logoUrl)}
                            alt="logo"
                            data-testid="login-logo"
                            className="mx-auto mb-4 md:mb-6"
                            style={{
                                width: 72, height: 72,
                                objectFit: "contain", background: "transparent",
                            }}
                            onError={() => setLogoUrl("")}
                        />
                    ) : (
                        <div
                            className="mx-auto mb-4 md:mb-6"
                            style={{
                                width: 72, height: 72, borderRadius: 20,
                                background: "var(--apple-blue-soft)",
                                color: "var(--apple-blue)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 32, fontWeight: 700,
                            }}
                        >
                            {namaPerusahaan.charAt(0)}
                        </div>
                    )}
                    <h1
                        className="text-xl md:text-3xl font-semibold mb-1 md:mb-2"
                        style={{ color: "var(--text-primary)", letterSpacing: "-0.5px" }}
                    >
                        {namaPerusahaan}
                    </h1>
                    <p className="text-sm md:text-base" style={{ color: "var(--text-secondary)", margin: 0 }}>
                        Buku Vendor Garment
                    </p>
                </div>
            </div>

            {/* Form panel */}
            <div className="login-form-panel">
                <form onSubmit={handleSubmit} data-testid="login-form" className="login-form-inner">
                    <h2
                        className="text-2xl md:text-3xl font-semibold mb-2"
                        style={{ color: "var(--text-primary)", letterSpacing: "-0.4px" }}
                    >
                        Masuk
                    </h2>
                    <p className="text-sm md:text-base mb-6 md:mb-8" style={{ color: "var(--text-secondary)" }}>
                        Silakan masuk dengan akun Anda.
                    </p>

                    <div className="mb-4">
                        <label htmlFor="email" className="block text-xs md:text-sm font-medium mb-1.5" style={{ color: "var(--text-primary)" }}>
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            inputMode="email"
                            data-testid="login-email-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="nama@meranggi.com"
                            className="login-input"
                            autoComplete="email"
                            autoFocus
                        />
                    </div>

                    <div className="mb-5">
                        <label htmlFor="password" className="block text-xs md:text-sm font-medium mb-1.5" style={{ color: "var(--text-primary)" }}>
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            data-testid="login-password-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            className="login-input"
                            autoComplete="current-password"
                        />
                        {errMsg && (
                            <div
                                data-testid="login-error-message"
                                className="mt-2 text-xs md:text-sm"
                                style={{ color: "var(--apple-red)" }}
                            >
                                {errMsg}
                            </div>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="login-submit-button"
                        className="login-submit"
                    >
                        {submitting ? "Memproses..." : "Masuk"}
                    </button>

                    <div className="mt-5 text-center">
                        <button
                            type="button"
                            disabled
                            data-testid="login-forgot-password"
                            className="text-xs md:text-sm"
                            style={{
                                background: "none", border: "none",
                                color: "var(--text-muted)",
                                cursor: "not-allowed",
                            }}
                            title="Hubungi pemilik akun untuk reset password"
                        >
                            Lupa password?
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
